import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import Radio, { RadioProps } from '@mui/material/Radio';
import { ImageProps } from 'next/image';

import * as iconStyles from './Icon.styles';
import Image from '../../../Image';
import {
  ButtonCheckboxIconProps,
  ButtonIconPropsBase,
  ButtonImageIconProps,
  ButtonRadioIconProps,
  IconType,
} from '../../BooleanButton.types';

export type IconProps = ButtonIconPropsBase | ButtonRadioIconProps | ButtonCheckboxIconProps | ButtonImageIconProps;

function Icon(props: IconProps) {
  const { classes } = iconStyles.useIconStyles();

  const { checked, type, ...moreProps } = props;

  switch (type) {
    case IconType.IMAGE:
      // eslint-disable-next-line jsx-a11y/alt-text
      return <Image height={52} width={52} {...(moreProps as ImageProps)} className={classes.image} />;
    case IconType.RADIO:
      return <Radio className={classes.markerPadding} {...(props as RadioProps)} checked={checked} />;
    case IconType.CHECKBOX:
    default:
      return <Checkbox className={classes.markerPadding} {...(props as CheckboxProps)} checked={checked} />;
  }
}

export default Icon;
